var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMultiWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4377 26.7262H25.241C21.9662 26.7262 19.302 24.0619 19.302 20.7872C19.302 17.5124 21.9662 14.8482 25.241 14.8482H30.4377C30.848 14.8482 31.1801 14.5161 31.1801 14.1057V11.8786C31.1801 10.3218 29.9725 9.05577 28.4469 8.933L24.1833 1.48599C23.7882 0.797243 23.1502 0.304975 22.3868 0.100565C21.627 -0.102453 20.8324 0.00417138 20.1524 0.399977L5.53654 8.90906H2.96955C1.33183 8.90906 0 10.2408 0 11.8786V29.6958C0 31.3335 1.33176 32.6653 2.96955 32.6653H28.2105C29.8482 32.6653 31.1801 31.3335 31.1801 29.6958V27.4686C31.1801 27.0583 30.848 26.7262 30.4377 26.7262ZM25.104 6.08365L26.7216 8.90906H20.251L25.104 6.08365ZM8.4875 8.90906L20.8998 1.68316C21.2355 1.48668 21.6277 1.43448 22.0025 1.53457C22.3817 1.63604 22.6978 1.8811 22.8943 2.22401L22.8958 2.22672L11.4184 8.90906H8.4875Z",
    fill: "url(#paint0_linear_740_5023)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.44 16.333H25.2433C22.7871 16.333 20.7891 18.331 20.7891 20.7873C20.7891 23.2436 22.7871 25.2416 25.2433 25.2416H30.44C31.6682 25.2416 32.6672 24.2426 32.6672 23.0144V18.5602C32.6672 17.332 31.6682 16.333 30.44 16.333ZM25.2433 22.272C24.4249 22.272 23.7586 21.6058 23.7586 20.7873C23.7586 19.9688 24.4249 19.3026 25.2433 19.3026C26.0618 19.3026 26.7281 19.9688 26.7281 20.7873C26.7282 21.6058 26.0619 22.272 25.2433 22.272Z",
    fill: "url(#paint1_linear_740_5023)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_740_5023",
    x1: 7.21407,
    y1: 18.4686,
    x2: 30.956,
    y2: 18.4632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_740_5023",
    x1: 23.5373,
    y1: 21.3698,
    x2: 32.5818,
    y2: 21.3669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiWallet);
export default __webpack_public_path__ + "static/media/multi-wallet.a705abe8e2d7ea618f7d7b8f98ee8b90.svg";
export { ForwardRef as ReactComponent };